/**
 * WARNING!! DO NOT MERGE THIS FILE WITH api-exceptions.ts
 * Webpack can't tree-shake our custom error classes. I moved zod-less code here to avoid this.
 */
export const VarietyPropertyName = '__AUDIENZZ_API_CLASS_VARIANT__';
export var ApiExceptions;
(function (ApiExceptions) {
    ApiExceptions["Error"] = "Error";
    ApiExceptions["Cancel"] = "Cancel";
})(ApiExceptions || (ApiExceptions = {}));
export function unsafeMakeApiError(obj) {
    return {
        ...obj,
        [VarietyPropertyName]: ApiExceptions.Error,
    };
}
